import React from "react";

export const MenuPopupContext = React.createContext({
  showMenuPopup: false,
  toggleMenuPopup: (shown: boolean) => {}
})
